import {Component, inject, input, InputSignal, model, ModelSignal, output, OutputEmitterRef, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DxListModule, DxPopupModule} from 'devextreme-angular';
import {SharedModule} from "../../../../../../shared/shared.module";
import {ButtonThemeEnum} from "../../../../../../shared/ui/button/button-theme-enum";
import {PointDeLivraisonDTO} from '../../../../../../core/dtos/point-de-livraison-d-t-o';
import {ContratMenuConviveDTO} from '../../../../../../core/dtos/contratmenuconvive-dto';
import {PointDeLivraisonService} from '../../../../../../core/services/entities/point-de-livraison.service';
import {UtilsService} from '../../../../../../core/utils/utils.service';
import {ToastService} from '../../../../../../core/services/technique/toast.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../../../../core/constants';
import {confirm} from 'devextreme/ui/dialog';

@Component({
  selector: 'yo-dialog-delete-plc',
  templateUrl: './dialog-delete-plc.component.html',
  styleUrls: ['./dialog-delete-plc.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, DxPopupModule, DxListModule, SharedModule],
  encapsulation: ViewEncapsulation.None
})
export class DialogDeletePlcComponent {

  displayRemoveDialog: ModelSignal<boolean> = model<boolean>(false);
  plcList: InputSignal<PointDeLivraisonDTO[]> = input<PointDeLivraisonDTO[]>([]);
  plcToRemoveList: InputSignal<PointDeLivraisonDTO[]> = input<PointDeLivraisonDTO[]>([]);
  contratMenuConvive: InputSignal<ContratMenuConviveDTO | undefined> = input<ContratMenuConviveDTO>();

  plcListChange: OutputEmitterRef<PointDeLivraisonDTO[]> = output<PointDeLivraisonDTO[]>();

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  selectedPlcToRemoveList: PointDeLivraisonDTO[] = [];

  #pdlSvc = inject(PointDeLivraisonService);
  #utils = inject(UtilsService);
  #toastSvc = inject(ToastService);

  closeDialog(): void {
    this.selectedPlcToRemoveList = [];
    this.displayRemoveDialog.set(false);
  }

  async detachSelectedPlc(): Promise<void> {
    if (this.#utils.isCollectionNullOrEmpty(this.selectedPlcToRemoveList) || this.#utils.isNullOrEmpty(this.contratMenuConvive())) {
      return;
    }

    const isConfirmed = await confirm(
      `Etes vous sûr de retirer les points de livraison sélectionnés de la prestation "${this.contratMenuConvive().libelle}" ?`,
      'Suppression de point de livraison'
    );
    if (!isConfirmed) return;

    this.#pdlSvc.detachFromPrestation(this.contratMenuConvive(), this.selectedPlcToRemoveList).subscribe(response => {
      if (!this.#utils.isResponseSupplierError(response)) {
        this.#toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
          `Points de livraison retirés de la prestation "${this.contratMenuConvive().libelle}".`);
        this.plcListChange.emit(this.#buildFilteredPlcList(this.plcList(), this.selectedPlcToRemoveList));
        this.closeDialog();
      }
    });
  }

  #buildFilteredPlcList(currentList: PointDeLivraisonDTO[], toRemove: PointDeLivraisonDTO[]): PointDeLivraisonDTO[] {
    const removedIds = new Set(toRemove.map(plc => plc.id));
    return currentList.filter(plc => !removedIds.has(plc.id));
  }
}
